export function SceneToast({ message }) {
  if (!message) return null
  return (
    <div id="toast" className="show">
      <span>◆</span>
      <span>{message}</span>
    </div>
  )
}
